module.exports = __webpack_public_path__ + "static/media/lodha.846175e2.svg";